import { IAppContext } from 'App/AppContext';
import { TFunction } from 'i18next';
import { AIAssistantName } from 'models/setting';

/**
 * The name the AI assistant goes by in this tenant: the name an administrator typed under
 * Administration, Automation, or the localized default when none is set. Every surface that names
 * the assistant (the panel header, the pane beside a task, the document editor) asks here, so a
 * renamed assistant is renamed everywhere. The caller's translation function must carry the
 * `copilot` namespace, or the default comes back as a raw key.
 */
export const getAIAssistantName = (appContext: IAppContext, t: TFunction<string[]>): string => {
  let custom: string | undefined;
  try {
    custom = (appContext.globalDataCache.settings.get(AIAssistantName) as string | undefined)?.trim();
  } catch {
    // the cache has no such setting yet (an older login): the default name applies
    custom = undefined;
  }

  return custom || t('copilot:Panel.Title');
};
